import { Model } from 'dva'
import { ASRModel } from '../types'
import { AsrService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const ASRModels: Model = {
  namespace: 'asrModels',
  state: {
    list: [],
  },
  effects: {
    *list(
      { id, useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let asrModels = yield select((state: any) =>
          state.asrModels.list.filter((item: ASRModel) => item.provider.id === id)
        )
        if (!(asrModels.length > 0 && useCache)) {
          asrModels = yield call(AsrService.asrModelsList, {
            providerPk: id,
          })
          yield put({ type: 'modifyList', payload: asrModels })
        }
        onSuccess(asrModels)
      } catch (err: any) {
        FailureHandler('Error fetching ASR Models', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { providerId, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let asrModel = yield select((state: any) =>
          state.asrModels.list.find((asrModel: ASRModel) => asrModel.id === id)
        )
        if (!asrModel) {
          asrModel = yield call(AsrService.asrModelsRetrieve, {
            id: id,
            providerPk: providerId,
          })
        }
        yield put({ type: 'modifyList', payload: asrModel })
        onSuccess(asrModel)
      } catch (err) {
        FailureHandler('Could not find the ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { providerId, data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(AsrService.asrModelsCreate, {
          requestBody: data,
          providerPk: providerId,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, providerId, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(AsrService.asrModelsPartialUpdate, {
          id: id,
          providerPk: providerId,
          requestBody: data,
        })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a ASR Model!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { idParentAlias, id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(AsrService.asrModelsDestroy, {
          id: id,
          providerPk: idParentAlias,
        })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a asrModel', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: ASRModel) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: ASRModel) => !action.payload.map((p: ASRModel) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: ASRModel) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetASRModels(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default ASRModels
